export const FIELDS = {
    stripeSubscriptionId: 'stripeSubscriptionId',
    companyName: 'companyName',
    email: 'email',
    trialExpire: 'trialExpire',
    notifiedAboutCompanyRemovingDate: 'notifiedAboutCompanyRemovingDate',
    country: 'country',
    state: 'state',
    city: 'city',
    region: 'region',
    appLanguage: 'appLanguage',
    address1: 'address1',
    address2: 'address2',
    zipCode: 'zipCode',
    billingCountry: 'billingCountry',
    billingState: 'billingState',
    billingCity: 'billingCity',
    billingAddress1: 'billingAddress1',
    billingAddress2: 'billingAddress2',
    billingZipCode: 'billingZipCode',
    workPhone: 'workPhone',
    showUsedTicketsCount: 'showUsedTicketsCount',
    billingUsage: 'billingUsage',
    isOldSubscription: 'isOldSubscription',
    failedSubscription: 'failedSubscription',
    subscriptionExpiredDate: 'subscriptionExpiredDate',
    isVerified: 'isVerified',
    isManuallyVerified: 'isManuallyVerified',
    showPopupNotifications: 'showPopupNotifications',
    subscriptionDate: 'subscriptionDate',
    subscriptionPlan: 'subscriptionPlanId',
    paymentCustomerId: 'paymentCustomerId',
    isManualSubscribed: 'isManualSubscribed',
    integrationsCount: 'integrationsCount',
    endlessIntegrations: 'endlessIntegrations',
    isCasesModuleActivated: 'isCasesModuleActivated',
    autoDraftEnabled: 'autoDraftEnabled'
};

export const DATA_REMOVE_FIELDS = {
    dataLifetime: 'dataLifetime',
    ordersDataLifetime: 'ordersDataLifetime',
    feedbacksDataLifetime: 'feedbacksDataLifetime',
    archiveThreadsLifetime: 'archiveThreadsLifetime',
    deletedDataLifetime: 'deletedDataLifetime'
};

export const SHOPIFY_BILLING_INFO_FIELDS = {
    shopifyBillingShopUrl: 'shopifyBillingShopUrl',
    status: 'status',
    activationDate: 'activationDate',
    createdDate: 'createdDate',
    subscriptionId: 'subscriptionId',
    tempReplycoSubscriptionId: 'tempReplycoSubscriptionId'
};

export const DATE_FIELDS = [FIELDS.trialExpire, FIELDS.notifiedAboutCompanyRemovingDate, FIELDS.subscriptionExpiredDate];
export const DATE_TIME_FIELDS = [FIELDS.subscriptionDate];

export const FIELD_TYPES = {
    input: 'input',
    date: 'date',
    number: 'number',
    select: 'select',
    switch: 'switch'
};

export const TABS = {
    general: 'general',
    accountSetup: 'accountSetup',
    subscription: 'subscription',
    features: 'features',
    administration: 'administration'
};

export const TAB_FIELDS = {
    [TABS.general]: [
        FIELDS.region,
        FIELDS.appLanguage,
        FIELDS.isVerified,
        FIELDS.isManuallyVerified,
        FIELDS.showPopupNotifications
    ],
    [TABS.subscription]: [
        FIELDS.stripeSubscriptionId,
        FIELDS.subscriptionDate,
        FIELDS.subscriptionPlan,
        FIELDS.paymentCustomerId,
        FIELDS.isManualSubscribed,
        FIELDS.trialExpire,
        FIELDS.notifiedAboutCompanyRemovingDate,
        FIELDS.subscriptionExpiredDate,
        FIELDS.integrationsCount,
        FIELDS.endlessIntegrations,
        FIELDS.billingUsage,
        FIELDS.isOldSubscription,
        FIELDS.failedSubscription,
        FIELDS.showUsedTicketsCount
    ],
    [TABS.features]: [
        FIELDS.isCasesModuleActivated,
        FIELDS.autoDraftEnabled
    ],
    [TABS.administration]: Object.values(DATA_REMOVE_FIELDS)
};

export const CHILD_MODALS = {
    delete: 'delete',
    manualSubscription: 'manualSubscription'
};

export const MODAL_WIDTH = 700;
export const COPY_FEEDBACK_DURATION = 2000;
